import React from 'react';
import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  Paper,
  Grid
} from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * AI 夥伴選擇組件
 */
const PartnerSelector = ({ availablePartners = [], selectedPartners = [], onChange }) => {
  const { t } = useTranslation('homepage');
  const [enabled, setEnabled] = React.useState(selectedPartners.length > 0);

  const handleToggleEnabled = (e) => {
    const isEnabled = e.target.checked;
    setEnabled(isEnabled);
    if (!isEnabled) {
      onChange([]);
    }
  };

  const handleTogglePartner = (partnerRef) => {
    if (selectedPartners.includes(partnerRef)) {
      onChange(selectedPartners.filter(p => p !== partnerRef));
    } else {
      onChange([...selectedPartners, partnerRef]);
    }
  };

  // 將 availablePartners 標準化為統一格式
  // 支援字串陣列（如 ["理工腦小生", "哆啦A夢"]）或物件陣列（如 [{reference: "...", name: "..."}]）
  const normalizedPartners = availablePartners.map(partner => {
    if (typeof partner === 'string') {
      return { reference: partner, name: partner, description: '' };
    }
    return partner;
  });

  return (
    <Box>
      <FormControlLabel
        control={
          <Checkbox 
            checked={enabled}
            onChange={handleToggleEnabled}
          />
        }
      label={t('partnerSelector.enablePartners')}
      />

      {enabled && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2" sx={{ mb: 2 }}>
            {t('partnerSelector.selectPartners')}
          </Typography>
          <Grid container spacing={2}>
            {normalizedPartners.map((partner) => (
              <Grid item xs={12} sm={6} key={partner.reference}>
                <Paper
                  sx={{
                    p: 2,
                    cursor: 'pointer',
                    border: selectedPartners.includes(partner.reference) ? '2px solid #1976d2' : '1px solid #e0e0e0',
                    backgroundColor: selectedPartners.includes(partner.reference) ? '#e3f2fd' : 'transparent',
                    '&:hover': {
                      backgroundColor: selectedPartners.includes(partner.reference) ? '#bbdefb' : '#f5f5f5'
                    }
                  }}
                  onClick={() => handleTogglePartner(partner.reference)}
                >
                  <FormControlLabel
                    control={
                      <Checkbox 
                        checked={selectedPartners.includes(partner.reference)}
                        onChange={() => handleTogglePartner(partner.reference)}
                      />
                    }
                    label={
                      <Box>
                        <Typography variant="subtitle1">
                          {partner.name}
                        </Typography>
                        {partner.description && (
                          <Typography variant="body2" color="text.secondary">
                            {partner.description}
                          </Typography>
                        )}
                      </Box>
                    }
                  />
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default PartnerSelector;
